<div>
  <span>{{userName}}</span><span>{{messagePartA}}</span><a class="id37-link"
                                                           (click)="goToCustomers()">{{messagePartB}}</a>
</div>
